import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters, mapState } from 'vuex';

const chatModule = StoreModuleMap[ItemTypeConsts.chat];

const CHAT_INTERACTION_ID = 260628; // the id for the drift playbook
const CHAT_NAME = 'paymentChat';

export default {
  created() {
    if (window) {
      const { email, firstname, lastname } = this.user;
      this.loadScript();
      this.updateOrg(this.orgId);
      this.updateUserSettings({ email, firstname, lastname });
    }
  },

  computed: {
    ...mapGetters(chatModule, {
      isChatLoading: 'getIsLoading',
    }),

    ...mapState('SettingsModule', [
      'orgId',
      'user',
    ]),
  },

  methods: {
    ...mapActions(chatModule, [
      'loadScript',
      'toggleChat',
      'updateOrg',
      'updateUserSettings',
    ]),

    handlePaymentChat(eventCb) {
      if (this.isChatLoading) return;
      eventCb();
      this.toggleChat({
        interactionId: CHAT_INTERACTION_ID,
        chatName: CHAT_NAME,
      });
    },
  },
};
